<dialog
  #selfAuthoringCreateDialog
  qai-dialog
  class="self-authoring-dialog"
  [heading]="isKnowledgeCheck()
    ? ('simulationBuilder.MODAL_TITLE' | transloco: { action: 'simulationBuilder.ACTION_CREATE_NEW' | transloco, type: 'simulationBuilder.ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY' | transloco })
    : ('simulationBuilder.CREATE_NEW_SIMULATION_BUTTON' | transloco)"
  [description]="'simulationBuilder.SELF_AUTHORING_DESCRIPTION' | transloco"
  (afterClose)="handleDialogClosed()"
>
  @if (open()) {
    @if (!isProcessing) {
      <self-authoring-simulation-form
        [open]="true"
        [isSelfAuthoringRoleplayEnabled]="true"
        [networkRequestInProgress]="networkRequestInProgress()"
        [errorStatus]="errorStatus()"
        [isFilesExceedingTokens]="isFilesExceedingTokens()"
        [prefillData]="prefillData()"
        [simulationType]="simulationType()"
        (confirmAction)="confirmAction.emit($event)"
        (closeModal)="closeModal.emit()"
        (dialogReopenRequested)="qaiDialogRef?.showModal()"
        (showLeaveConfirmationChange)="formShowLeaveConfirmation = $event"
        (isLeavingChange)="formIsLeaving = $event"
      ></self-authoring-simulation-form>
    } @else {
      <simulation-generation-modal
        [callUuid]="activeCallUuid()"
        [moduleUuid]="moduleUuid()"
        [retryInProgress]="retryInProgress()"
        (backToForm)="handleGenerationExit()"
        (backToFormWithPrefill)="backToFormWithPrefill.emit()"
        (reviewModalClosed)="handleGenerationExit()"
        (pollingTimedOut)="handlePollingTimedOut()"
        (retryClicked)="retryClicked.emit()"
      ></simulation-generation-modal>
    }
  }
</dialog>

@if (open() && !isProcessing) {
  <leave-confirmation-modal
    [open]="formShowLeaveConfirmation"
    (openChange)="formShowLeaveConfirmation = $event"
    [networkRequestInProgress]="formIsLeaving"
    (confirm)="formRef?.onLeaveConfirmed()"
    (closeModal)="formRef?.onLeaveCancelled()"
  ></leave-confirmation-modal>
}
